import React, { useState } from 'react';
import VideoPlayer from './VideoPlayer';
import ProgressBar from './progressBar/ProgressBar';
import { useAccount } from 'wagmi';
import { useHttp } from 'src/hooks';

const VideoPage: React.FC = () => {
  const [progress, setProgress] = useState<number>(0);
  const { address } = useAccount();
  const { sendRequest } = useHttp();

  const videoId = 'dQw4w9WgXcQ';

  const updateWatchedStatus = async (walletAddress: string) => {
    if (walletAddress) {
      sendRequest(
        {
          url: `youtube/update-watched-status/${walletAddress}`,
          method: 'POST',
        },
        (data: any) => {
          console.log(data);
        },
      );
    }
  };

  const handleProgress = (newProgress: number) => {
    setProgress(newProgress);
    if (address) {
      // Only trigger once when it crosses 25%
      if (newProgress >= 25 && newProgress < 26) {
        updateWatchedStatus(address);
      }
    }
  };

  return (
    <div className="bg-black min-h-screen flex justify-center items-center relative">
      <h1 className="absolute text-white text-4xl top-4 left-1/2 transform -translate-x-1/2 z-10">
        Watch Video
      </h1>

      <div className="relative w-full max-w-2xl">
        <VideoPlayer videoId={videoId} onProgress={handleProgress} />

        <div className="absolute top-2 right-2 w-32 bg-gray-300 rounded-full">
          <ProgressBar progress={progress} />
          <span className="absolute text-white right-0 -top-6 text-sm">{`${Math.round(
            progress,
          )}%`}</span>
        </div>
      </div>
    </div>
  );
};

export default VideoPage;
